import { uniqueId } from 'lodash-es';

import type { ILastDropData } from '../types/backend/last-drop-data.interface';
import type { IQuestMotivator } from '../types/backend/quest-motivator.interface';
import type { ITopGamer } from '../types/frontend/top-gamer.interface';

export const motivatorAdapter = (questMotivator: IQuestMotivator): ITopGamer[] => {
  return questMotivator.last?.map((d) => motivatorItemAdapter(d.data)) ?? [];
};

export const motivatorItemAdapter = (drop: ILastDropData): ITopGamer => {
  const uniqId = uniqueId();
  const newGamer = {
    id: uniqId,
    uniqId: uniqId,
    user: drop?.user,
    passed: drop?.passed,
    total: drop?.total,
    recentlyOpened: { icon: drop?.levelQuestUserLevel?.rewardResults?.[0]?.userInventoryItem?.inventoryItem?.baseItem?.icon || '' },
  };

  return newGamer;
};
